import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { StarInfoBadge } from '../../../../svgIcons';
import ClassetDropdown from '../../../../../classetComponents/classetDropDown';
import ClassetCalendar from '../../../../../classetComponents/classetCalender';
import ClassetTextArea from '../../../../../classetComponents/classetTextArea';

class AdmissionChangeRequestDialog extends Component {
    renderHeader = () => {
        return (
            <div className="mt-2 formHeadingInter">
                <div className="mb-3">
                    <StarInfoBadge />
                </div>
                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Change </p>
                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Student Admission Category</p>
            </div>
        );
    };

    renderFooter = () => {
        const { onSubmit, onCancel } = this.props;
        
        return (
            <div className="flex justify-content-center mb-4">
                <Button
                    className="formSubmitButton px-4"
                    style={{ borderRadius: '10px' }}
                    onClick={onSubmit}
                >
                    <p className="formSubmitButtonText">Request</p>
                </Button>
                <Button 
                    className="formCancelButton px-4" 
                    style={{ backgroundColor: '#F4F5F6', border: 0 }} 
                    onClick={onCancel}
                >
                    <p className="formCancelButtonText">Cancel</p>
                </Button>
            </div>
        );
    };

    render() {
        const {
            visible,
            onHide,
            selectedStudentData,
            admissionCategories,
            selectedAdmission,
            onAdmissionChange,
            effectiveDate,
            onEffectiveDateChange,
            remarks,
            onRemarksChange
        } = this.props;

        return (
            <Dialog
                visible={visible}
                draggable={false}
                closeOnEscape={false}
                style={{ width: 400 }}
                dismissableMask={false}
                closable={false}
                header={this.renderHeader}
                footer={this.renderFooter}
                onHide={onHide}
            >
                <div className="m-3 pt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <div 
                        className="flex align-items-center mb-3" 
                        style={{ 
                            background: "#f4f6fa", 
                            borderRadius: "8px", 
                            padding: "10px 16px" 
                        }}
                    >
                        <span style={{ 
                            fontWeight: "bold", 
                            color: "#333", 
                            fontSize: "1rem" 
                        }}>
                            Current Admission Category:
                        </span>
                        <span style={{ 
                            marginLeft: "8px", 
                            color: "#076EFF", 
                            fontWeight: "500", 
                            fontSize: "1rem" 
                        }}>
                            {selectedStudentData?.categoryName || "-"}
                        </span>
                    </div>
                    
                    <div className="">
                        <ClassetDropdown
                            label={'Admission Category'}
                            placeholder={'Select Admission Category'}
                            options={admissionCategories}
                            value={selectedAdmission}
                            onChange={(e) => onAdmissionChange(e.value)}
                            optionLabel="categoryName"
                            optionValue="_id"
                        />
                    </div>
                    
                    <div className='mt-3'>
                        <ClassetCalendar
                            label={"Effective Date"}
                            className='border-round-md no-border custom-field-focused border-none pl-3 body-medium'
                            calendarMode={'single'}
                            height="48px"
                            width='368px'
                            value={effectiveDate ? new Date(effectiveDate) : null}
                            onChange={(e) => onEffectiveDateChange(e.target.value)}
                            placeholder="Select Date"
                        />
                    </div>
                    
                    <div className="mt-3">
                        <div>
                            <ClassetTextArea 
                                width={'100%'} 
                                label={'Reason for change:'} 
                                placeholder="Remarks" 
                                value={remarks} 
                                onChange={(e) => onRemarksChange(e.target.value)} 
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default AdmissionChangeRequestDialog;
